import type { Ref } from 'react'

import { TEXTOS } from './textos'

/** O que chegou enquanto o painel estava recolhido, e ainda não foi visto. */
export type Novidade = 'resposta' | 'aviso' | null

/**
 * O botão flutuante. Some enquanto o painel está aberto — os dois são o mesmo
 * objeto em dois estados, e por isso dividem o ícone e o gradiente.
 */
export function BotaoDoAssistente({
  ref,
  flutuando,
  novidade,
  aoAbrir,
}: {
  ref: Ref<HTMLButtonElement>
  /**
   * Chama atenção até a primeira abertura. Depois disso é ruído, e a WCAG 2.2.2
   * pede que movimento com mais de 5s possa parar.
   */
  flutuando: boolean
  /**
   * Quem minimizou no meio de uma pergunta precisa saber que ela terminou.
   * `resposta` é boa notícia: um ponto na cor da marca. `aviso` (falha, limite)
   * leva o ícone de atenção — decisão com o Fábio em 05/10/2026.
   */
  novidade: Novidade
  aoAbrir: () => void
}) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={TEXTOS.abrir}
      aria-haspopup="dialog"
      aria-expanded={false}
      onClick={aoAbrir}
      className={`bg-gradient-brand text-text-inverse shadow-card-hover hover:brilho-fab rounded-control duration-base fixed right-6 bottom-6 z-40 flex size-14 items-center justify-center ease-out print:hidden ${
        flutuando ? 'animate-flutuar motion-reduce:animate-none' : ''
      }`}
    >
      <i className="ph ph-head-circuit text-2xl" aria-hidden="true" />
      {/* O selo é decorativo: quem não vê é avisado pela região `aria-live` que o
          `Assistente` mantém ao lado do botão. */}
      {novidade === 'resposta' && (
        <span
          aria-hidden="true"
          className="bg-iox-cyan border-surface-card rounded-control absolute -top-0.5 -right-0.5 size-4 border-2"
        />
      )}
      {novidade === 'aviso' && (
        <span
          aria-hidden="true"
          className="bg-warning-500 text-iox-black border-surface-card rounded-control absolute -top-1 -right-1 flex size-6 items-center justify-center border-2"
        >
          <i className="ph ph-warning text-sm" />
        </span>
      )}
    </button>
  )
}
